import { Button, Loading } from 'components'
import { authorizedRequest } from 'api'
import { noop } from 'utils'
import { useConfirmation } from 'hooks/useConfirmation'
import { useCallback, useState } from 'react'
import getLocalized from 'i18n'
const localized = getLocalized()

export type DeleteBtnProps = {
  userId: string
  disabled?: boolean
  onDone?: (message: string) => void
  onError?: (message: string) => void
}
export const DeleteBtn = ({
  disabled = false,
  userId,
  onDone = noop,
  onError = noop,
}: DeleteBtnProps) => {
  const [loading, setLoading] = useState<boolean>(false)

  const confirmClick = useConfirmation({
    header: localized.confirmationModal.delete.header,
    body: localized.confirmationModal.delete.body,
    confirmText: localized.confirmationModal.delete.confirmText,
  })

  const deleteUser = useCallback(async () => {
    if (await confirmClick()) {
      setLoading(true)
      try {
        const endpoint = `user/${userId}`
        const response = await authorizedRequest({
          endpoint,
          method: 'DELETE',
        })
        const json = await response.json()
        if (json.success) {
          setLoading(false)
          onDone('User deleted')
        } else {
          throw new Error(json.error)
        }
      } catch (e: any) {
        setLoading(false)
        onError(e.message)
      }
    }
  }, [userId, confirmClick, onDone, onError])

  return (
    <Button
      type="button"
      variant="buttons.outline"
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: 50,
      }}
      disabled={disabled || loading}
      onClick={async () => {
        deleteUser()
      }}
    >
      {loading ? <Loading /> : <span>Delete user</span>}
    </Button>
  )
}
